"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrientationFromTo = exports.orientationSchema = exports.orientationList = void 0;
exports.orientationList = ['left', 'right', 'top', 'bottom'];
exports.orientationSchema = exports.orientationList;
var getOrientationFromTo = function (from, to) {
    var diffX = to.x - from.x;
    var diffY = to.y - from.y;
    if (Math.abs(diffX) > Math.abs(diffY)) {
        return diffX > 0
            ? 'right'
            : 'left';
    }
    else {
        return diffY > 0
            ? 'bottom'
            : 'top';
    }
};
exports.getOrientationFromTo = getOrientationFromTo;
